// extracted by mini-css-extract-plugin
var _1 = "TextArea_default__CUIci";
var _2 = "TextArea_fullWidth__ld9gT";
var _3 = "TextArea_textarea__p4tNX";
var _4 = "TextArea_textareaError__oazxW";
export { _1 as "_default", _2 as "fullWidth", _3 as "textarea", _4 as "textareaError" }
